import { render } from "./TextLinkRenderer.vue?vue&type=template&id=e07a8bf6&scoped=true"
const script = {}

import "./TextLinkRenderer.vue?vue&type=style&index=0&id=e07a8bf6&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e07a8bf6"]])

export default __exports__